module.exports = __webpack_public_path__ + "img/auth-bg.6a1f652a.png";